import React from "react";
import { Link } from "react-router-dom";
import "./Layout.css";

const Layout = (props) => {
  return (
    <div className="layout-card">
      <div className="header">
        <div style={{ display: "flex" }}>
          <img className="headerIcon" src={props.headerIcon} alt="page icon" />
          <p className="headerText">{props.headerText}</p>
        </div>
        <div className="header-button">
          {props.button === "MANAGE WORKSHEET" ? (
            <Link to="/new/app/ManageWorkSheet">
              <button className="button">{props.button}</button>
            </Link>
          ) : props.button === "CREATE" ? (
            <Link
              to={{
                pathname: `/new/app/MyWorksheet/5952`,
              }}
            >
              <button className="button">{props.button}</button>
            </Link>
          ) : (
            <button className="button" onClick={props.click}>
              {props.button}
            </button>
          )}
        </div>
      </div>
      <div>{props.children}</div>
    </div>
  );
};

export default Layout;



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Layout/Layout.jsx